/**
 * @generated SignedSource<<342f97ac1c29fc1450d55c7df8b38e85>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarExperienceOld_project" | "ConditionalFormattingSidebarExperience_project">;
  readonly " $fragmentType": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project";
};
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$key = {
  readonly " $data"?: experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistry_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isSavedViewConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project",
  "selections": [
    {
      "condition": "isSavedViewConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "isConditionalFormattingEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ConditionalFormattingSidebarExperienceOld_project"
            }
          ]
        }
      ]
    },
    {
      "condition": "isSavedViewConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ConditionalFormattingSidebarExperience_project"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "6062124258e30f13bb5ba27435575c95";

export default node;
